export * from './clients.service';
import { ClientsService } from './clients.service';
export * from './settings.service';
import { SettingsService } from './settings.service';
export * from './transactions.service';
import { TransactionsService } from './transactions.service';
export const APIS = [ClientsService, SettingsService, TransactionsService];
